import getConfig from "next/config";
import axios from "axios";

/**
 * Common fetch api
 * @param url
 */
export async function get<T>(url: string): Promise<T> {
  try {
    return await axios
      .get(url, { timeout: 50000 })
      .then((response) => {
        if (response.status != 200) {
          return null;
        }
        return response.data;
      })
      .catch((err) => null);
  } catch (err) {
    return null;
  }
}

export async function post<T>(url: string, postData: any): Promise<T> {
  try {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json"
    };

    return await axios
      .post(url, postData, {
        headers,
        timeout: 5000
      })
      .then((response) => {
        if (response.status != 200) {
          throw new Error(response.statusText);
        }
        return response.data;
      })
      .catch((err) => {
        throw new Error(err);
      });
  } catch (err) {
    throw new Error(err);
  }
}
